import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * NavbarStart - A className-based implementation that matches the Bulma NavbarStart
 * 
 * This component provides the same API as Bloomer's NavbarStart for easy migration
 */
const NavbarStart = ({
  children,
  className,
  ...rest
}) => {
  const navbarStartClasses = classNames('navbar-start', {
    [className]: className,
  });

  return (
    <div className={navbarStartClasses} {...rest}>
      {children}
    </div>
  );
};

NavbarStart.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

NavbarStart.defaultProps = {
  children: null,
  className: '',
};

export default NavbarStart;
